<template>
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path d="M8.00001 0C9.86028 0 11.5647 0.63769 12.9223 1.70432C13.3451 2.03644 13.9582 2.04184 14.3383 1.6617C14.9515 1.04849 16 1.48279 16 2.35V7H11.4142C10.5233 7 10.0772 5.92286 10.7071 5.29289L11.5162 4.48386C11.9054 4.0946 11.911 3.45582 11.4657 3.1321C10.4917 2.42392 9.30115 2 8.00001 2C4.69001 2 2.00001 4.69 2.00001 8C2.00001 10.9708 4.16696 13.4422 7.00423 13.9175C7.54892 14.0087 8.00001 14.4477 8.00001 15C8.00001 15.5523 7.55005 16.0066 7.00198 15.9384C3.05481 15.4475 0.0100098 12.0819 0.0100098 8C0.0100098 3.58 3.58001 0 8.00001 0Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
